import Dropdown from "../../../../../Components/common/Dropdown/Dropdown";

const AutoSubmissionSidebar = ({ items, onItemSelect, selectedItem }) => {
  return (
    <div className="auto-submission-sidebar">
      <Dropdown
        title="Auto Submission"
        selectedItem={selectedItem}
        items={items}
        onItemSelect={onItemSelect}
      />
    </div>
  );
};

export default AutoSubmissionSidebar;
